module.exports = __webpack_public_path__ + "static/media/TMDBLogo.12d095ee.svg";